// extracted by mini-css-extract-plugin
export default {"container":"healthmonitoringmaxvalues_container__JzDbv","item_right":"healthmonitoringmaxvalues_item_right__bAXpG","border":"healthmonitoringmaxvalues_border__ZAoNh"};